import * as e from "react";
import c from "../lib/IconBase.es.js";
import s from "../defs/UserCircleGear.es.js";
const r = e.forwardRef((o, a) => /* @__PURE__ */ e.createElement(c, { ref: a, ...o, weights: s }));
r.displayName = "UserCircleGearIcon";
const m = r;
export {
  m as UserCircleGear,
  r as UserCircleGearIcon
};
